import { getItem } from '@sketch/utils'
import { localStorageKeys } from '@sketch/constants'
import env from './appEnv'

export const isBillingHidden = (() => {
  if (env.is_private_cloud) return true

  if (
    (process.env.REACT_APP_ENV === 'dev' ||
      process.env.REACT_APP_ENV === 'test') &&
    getItem(localStorageKeys.hideBilling) === 'true'
  ) {
    return true
  }

  return false
})()

const devEnvs = ['dev', 'test', 'local']

/**
 * True when the current the app is hosted on a private cloud instance.
 *
 * Can be overridden in certain environments using `localStorage`.
 */
export const isPrivateCloud = (() => {
  if (env.is_private_cloud) return true

  const isDevEnv = devEnvs.includes(process.env.REACT_APP_ENV || '')

  if (isDevEnv && getItem(localStorageKeys.isPrivateCloud) === 'true') {
    return true
  }

  return false
})()
